import { Link, useParams, useNavigate } from "react-router-dom";




const VipTablesTabs = ({ tab }) => {
    let params = useParams();
    return (
        <ul className="nav premium-tabs mb-4">
            <li className="nav-item">
                <Link className={tab === "payments" ? "nav-link active" : "nav-link"} to={`/my/nightspots/${params.id}/payments/details`}>
                    <i className="fa-solid fa-wallet me-2"></i>Pagamentos
                </Link>
            </li>
            <li className="nav-item">
                <Link className={tab === "invoice" ? "nav-link active" : "nav-link"} to={`/my/nightspots/${params.id}/payments/invoice/details`}>
                    <i className="fa-solid fa-file-invoice-dollar me-2"></i>Detalhes Faturação
                </Link>
            </li>
            <li className="nav-item">
                <Link className={tab === "terms" ? "nav-link active" : "nav-link"} to={`/my/nightspots/${params.id}/tables/terms`}>
                    <i className="fa-solid fa-gavel me-2"></i>Termos & Condições
                </Link>
            </li>
        </ul>
    )
}

export default VipTablesTabs;